import { IEntity } from '../types';
import { EntityService } from './EntityService';

export class RiskAppImpactTypeService extends EntityService<IEntity> {
    constructor() {
        super(`/RiskAppImpactTypes`);
    }
}
